import { Box } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet-async';

export interface PageProps {
  title?: string;
  children?: React.ReactNode;
  ref?: React.RefObject<HTMLDivElement>;
}

export default function Page({ title, children, ref, ...other }: PageProps) {
  return (
    <Box ref={ref} {...other}>
      <Helmet>
        <title>{`Flamboyant | ${title}` || 'Flamboyant'}</title>
      </Helmet>
      {children}
    </Box>
  );
}
